/* global axios */
import ApiClient from './ApiClient';

class AgentVoiceProfilesAPI extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  profileURL(agentId) {
    return `${this.url}/${agentId}/voice_profile`;
  }

  listReady() {
    return axios.get(`${this.baseUrl()}/agent_voice_profiles`);
  }

  get(agentId) {
    return axios.get(this.profileURL(agentId));
  }

  create(agentId, payload) {
    return axios.post(this.profileURL(agentId), payload);
  }

  update(agentId, payload) {
    return axios.patch(this.profileURL(agentId), payload);
  }

  removeReferenceAudio(agentId, attachmentId) {
    return axios.delete(
      `${this.profileURL(agentId)}/reference_audios/${attachmentId}`
    );
  }

  delete(agentId) {
    return axios.delete(this.profileURL(agentId));
  }
}

export default new AgentVoiceProfilesAPI();
